import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAIElement, OpenAIRole } from 'src/app/models/chatAiMessage';

@Component({
  selector: 'chat-ai-bubble',
  templateUrl: './chat-ai-bubble.component.html',
  styleUrls: ['./chat-ai-bubble.component.scss'],
})
export class ChatAIBubbleComponent {

  @Input() message: IAIElement;
  @Input() mascotteAvatar: string;
  @Output() selected: EventEmitter<boolean> = new EventEmitter();

  constructor(
  ) {}

  isMy() {
    const { role = '' } = this.message;
    return role === OpenAIRole.user;
  }

  isLoading() {
    const { isLoading = false } = this.message;
    return isLoading;
  }

  isConfirm() {
    const { isConfirm = false } = this.message;
    return isConfirm;
  }

  confirmManually() {
    this.selected.emit(true);
  }
}
